import * as React from 'react'
import * as PropTypes from 'prop-types'
import { Redirect, Route } from 'react-router'
// import getSiteMaintenanceRedirect from '../../../services/redirection/getSiteMaintenanceRedirect'

function ControlledRoute(props) {
  const {
    render,
    component: Component,
    redirect,
    baseUrl,
    webview,
    ...theProps
  } = props

  return (
    <Route
      {...theProps}
      render={renderProps => {
        // const {
        //   location: { pathname: currPath },
        // } = renderProps

        // const isMaintenance =
        //   typeof window !== 'undefined' &&
        //   window.sessionStorage.getItem('triggerShutDown')

        // const maintenancePath = getSiteMaintenanceRedirect(
        //   currPath,
        //   isMaintenance,
        // )
        const redirectPath = redirect()

        // if (typeof maintenancePath === 'string') {
        //   return <Redirect to={maintenancePath} />
        // }

        if (typeof redirectPath === 'string') {
          return <Redirect to={redirectPath} />
        }

        if (Component) {
          return (
            <Component
              baseUrl={baseUrl || ''}
              webview={webview || false}
              {...renderProps}
            />
          )
        }

        if (render) {
          return render(props)
        }

        return null
      }}
    />
  )
}

ControlledRoute.defaultProps = {
  redirect: () => false,
}

ControlledRoute.propTypes = {
  redirect: PropTypes.func,
  component: PropTypes.func,
}

export default ControlledRoute
